<template>
	<div class="base-loader" :style="{ width }">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style="
				margin: auto;
				display: block;
				shape-rendering: auto;
				animation-play-state: running;
				animation-delay: 0s;
			"
			width="200px"
			height="200px"
			viewBox="0 0 100 100"
			preserveAspectRatio="xMidYMid"
		>
			<circle
				cx="50"
				cy="50"
				fill="transparent"
				:stroke="color"
				stroke-width="10"
				r="35"
				stroke-dasharray="164.93361431346415 56.97787143782138"
				style="animation-play-state: running; animation-delay: 0s"
			>
				<animateTransform
					attributeName="transform"
					type="rotate"
					repeatCount="indefinite"
					dur="1s"
					values="0 50 50;360 50 50"
					keyTimes="0;1"
					style="animation-play-state: running; animation-delay: 0s"
				/>
			</circle>
		</svg>
	</div>
</template>
<script>
export default {
	name: 'BaseLoader',
	props: {
		color: { type: String, required: false, default: '#2965FE' },
		width: { type: String, required: false, default: '30px' },
	},
}
</script>
<style scoped lang="postcss">
.base-loader {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	font-size: 16px;
	color: #666;
	width: 100%;
	margin: auto;

	svg {
		width: 5rem;
		height: 100%;
	}
}
</style>
